import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const MentorSidebarLinks = ({ isCollapsed }) => {
  const location = useLocation();
  const isPenilaianActive = location.pathname.includes('/mentor/mentees/evaluations') || location.pathname.includes('/mentor/classifications');
  return (
    <>
      {/* Dashboard */}
      <NavLink
        to='/mentor'
        end
        className={({ isActive }) =>
          isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Dashboard' : ''}
      >
        <i className='bi bi-house-fill'></i>
        <span className='sidebar-collapsed-text'>Dashboard</span>
      </NavLink>

      {/* Pendaftaran */}
      <NavLink
        to='/mentor/registrations'
        className={({ isActive }) =>
          isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Pendaftaran' : ''}
      >
        <i className='bi bi-box-arrow-in-right'></i>
        <span className='sidebar-collapsed-text'>Pendaftaran</span>
      </NavLink>

      {/* Penilaian Dropdown */}
      <div className={isCollapsed ? 'dropend' : 'dropdown'}>
        <a
          href='/#'
          data-bs-toggle='dropdown'
          data-bs-boundary='viewport'
          data-bs-offset='0,0'
          data-bs-strategy='fixed'
          className={`sidebar-link dropdown-toggle text-decoration-none ${isPenilaianActive ? 'active text-white' : 'link-body-emphasis'}`}
          title={isCollapsed ? 'Penilaian' : ''}
        >
          <i className='bi bi-hand-thumbs-up-fill'></i>
          <span className='sidebar-collapsed-text'>Penilaian</span>
        </a>
        <ul
          className='dropdown-menu text-small shadow border-0 rounded-4 p-2'
          style={{ zIndex: 2050 }}
        >
          <li className='nav-item'>
            <NavLink
              to='/mentor/mentees/evaluations'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3 mb-1'
                  : 'dropdown-item rounded-3 mb-1 text-decoration-none'
              }
            >
              Mahasiswa
            </NavLink>
            <NavLink
              to='/mentor/classifications'
              className={({ isActive }) =>
                isActive
                  ? 'dropdown-item active rounded-3'
                  : 'dropdown-item rounded-3 text-decoration-none'
              }
            >
              KPI
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Absensi */}
      <NavLink
        to='/mentor/attendances'
        className={({ isActive }) =>
          isActive
            ? 'sidebar-link active text-decoration-none'
            : 'sidebar-link link-body-emphasis text-decoration-none'
        }
        title={isCollapsed ? 'Absensi' : ''}
      >
        <i className='bi bi-calendar-check'></i>
        <span className='sidebar-collapsed-text'>Absensi</span>
      </NavLink>
    </>
  );
};

export default MentorSidebarLinks;
